import { IUserState } from 'src/interface';
import { ACTIONS } from 'src/redux/actions/user/dispatchActions';
import * as handlerFn from './handlerFn';
const handler: any = {};

handler[ACTIONS.SET_ASSETS] = (
    state: IUserState,
    payload: IUserState
): IUserState => {
    return handlerFn.updateUserAssets(state, payload);
};

handler[ACTIONS.FOLLOW] = (
    state: IUserState,
    payload: {
        objectType: string;
        objectId: number;
    }
): IUserState => {
    return handlerFn.follow(state, payload.objectType, payload.objectId);
};

handler[ACTIONS.LIKE] = (
    state: IUserState,
    payload: {
        id: number;
    }
): IUserState => {
    return handlerFn.like(state, payload.id);
};

handler[ACTIONS.BOOKMARK] = (
    state: IUserState,
    payload: {
        id: number;
    }
): IUserState => {
    return handlerFn.bookmark(state, payload.id);
};

export default handler;
